// Environment configuration
// Values are read from Vite's import.meta.env

export const config = {
  // Supabase
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string,

  // Backend server
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string || 'http://localhost:8080',

  // WebSocket URL (derived from API base URL)
  get wsUrl(): string {
    const base = this.apiBaseUrl;
    return base.replace('https://', 'wss://').replace('http://', 'ws://') + '/ws';
  },

  // Game settings
  tickRate: 20, // Client input tick rate (Hz)
  snapshotInterpolationMs: 100, // Interpolation buffer

  // Feature flags
  debugMode: import.meta.env.DEV,
  enableWebGPU: true,
} as const;

// Validate required environment variables in development
if (import.meta.env.DEV) {
  const required = ['VITE_SUPABASE_URL', 'VITE_SUPABASE_ANON_KEY'];
  const missing = required.filter(key => !import.meta.env[key]);
  if (missing.length > 0) {
    console.warn(`Missing environment variables: ${missing.join(', ')}`);
    console.warn('Copy .env.example to .env and fill in the values');
  }
}
